"use client";
import { useEffect } from "react";
import { useSWRConfig } from "swr";
import { COST_PRICES_CHANGED, resourceDependsOnCosts } from "@/lib/api/cost-change-events";

// Multiple cards/blocks can share the same SWR key. One revalidation per
// event and cache owner avoids forcing duplicate requests from each block.
const claimed = new WeakMap<Event, WeakMap<object, Set<string>>>();
export function useCostRefresh(key: string | null, url: string | null, mutate: () => Promise<unknown>) {
  const { cache } = useSWRConfig();
  useEffect(() => {
    if (!key || !resourceDependsOnCosts(url)) return;
    const update = (event: Event) => {
      let owners = claimed.get(event);
      if (!owners) { owners = new WeakMap(); claimed.set(event, owners); }
      let keys = owners.get(cache);
      if (!keys) { keys = new Set(); owners.set(cache, keys); }
      if (keys.has(key)) return;
      keys.add(key);
      void mutate().catch(() => {});
    };
    window.addEventListener(COST_PRICES_CHANGED, update);
    return () => window.removeEventListener(COST_PRICES_CHANGED, update);
  }, [cache, key, url, mutate]);
}
